import { render, staticRenderFns } from "./Jenis.vue?vue&type=template&id=03c49de3&scoped=true"
import script from "./Jenis.vue?vue&type=script&lang=js"
export * from "./Jenis.vue?vue&type=script&lang=js"
import style0 from "./Jenis.vue?vue&type=style&index=0&id=03c49de3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c49de3",
  null
  
)

export default component.exports